import { ApiException } from '@eta/components';
import {
    OTPVerifyUser,
    VerficationActionTypes,
    OTPVerifyTaxpayer,
    OTPVerifyIntermediary
} from './Types';

export interface VerifyState {
    lastError?: ApiException;
}

const initialState: VerifyState = {};

export function VerifyReducer(
    state = initialState,
    action: VerficationActionTypes
) {
    switch (action.type) {
        case OTPVerifyUser:
            return {
                ...state,
                ...action.payload,
            };
        case OTPVerifyTaxpayer:
            return {
                ...state,
                ...action.payload,
            };
        case OTPVerifyIntermediary:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}
